import { TestModule } from '#src/extractTestsFromModule';
import { ObjectField } from './models/objectField.js';

/**
 * Extracts all properties from a module or object and wraps them in `ObjectField` instances.
 * 
 * @param groupName - The parent group name for the extracted fields.
 * @param moduleToParse - The object or module to extract fields from.
 * @returns An array of `ObjectField` representing the properties of the object.
 */
export function parseObjectFields(groupName: string, moduleToParse: TestModule): ObjectField[] {
  const fields: ObjectField[] = [];
  fields.push(
    ...Object.keys(moduleToParse)
      .map(name => new ObjectField(groupName, name, moduleToParse[name])
      )
  );

  return fields;
}
